import type { init } from '@sentry/react';

type SentryDataCollection = NonNullable<NonNullable<Parameters<typeof init>[0]>['dataCollection']>;

const DENIED_KEY_FRAGMENTS = ['forwarded', '-ip', 'remote-', 'via', '-user', 'patient'];

// Sentry v11 collects user IP, cookies, request/response bodies and GraphQL variables by default
// when dataCollection is unset. These can carry PHI, so keep the v10 (sendDefaultPii off) baseline.
// Never leave this unset or drop a key — see the v11 MIGRATION.md "sendDefaultPii is replaced by dataCollection".
export const SENTRY_DATA_COLLECTION: SentryDataCollection = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: { deny: DENIED_KEY_FRAGMENTS },
    response: { deny: DENIED_KEY_FRAGMENTS },
  },
  httpBodies: [],
  urlQueryParams: { deny: DENIED_KEY_FRAGMENTS },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  graphQL: { document: false, variables: false },
};
